import React from 'react';

import Tooltip from '../../library/tooltip/tooltip';
import Typography from '../../library/typography/typography';
import RatingsChart from '../ratings-chart/ratings-chart';

import { Maybe } from '../../shared/types/graphql-types';

import './treadwell-bar-row.scss';

export enum TreadwellBarRowColor {
  BLUE = 'blue',
  GREEN = 'green',
  GREY = 'grey',
  GREY_BLUE = 'greyblue'
}

interface TreadwellBarRowInterface {
  barColor?: TreadwellBarRowColor;
  className?: string;
  formattedValue?: string;
  hideFill?: boolean;
  icon?: () => React.ReactElement;
  maxRatingLabel?: string;
  midRatingLabel?: string;
  minRatingLabel?: string;
  scale?: number;
  showValueMarker?: boolean;
  showZeroValue?: boolean;
  title?: Maybe<string>;
  tooltip?: Maybe<string>;
  value: number;
}

function TreadwellBarRow(props: TreadwellBarRowInterface) {
  const {
    barColor = TreadwellBarRowColor.GREY,
    className = '',
    formattedValue,
    hideFill,
    icon: Icon,
    maxRatingLabel,
    midRatingLabel,
    minRatingLabel,
    scale,
    showValueMarker = false,
    showZeroValue = false,
    title,
    tooltip,
    value
  } = props;
  const ratingsChartStyleName = `ratings-chart ${barColor}`;

  return (
    <div className={`treadwell-bar-row ${className}`} styleName="container">
      {title && (
        <div className="treadwell-bar-row__title" styleName="title">
          {Icon && <Icon styleName="icon" />}
          <Typography weight="bold">{title}</Typography>
          {tooltip && <Tooltip content={tooltip} styleName="tooltip" />}
        </div>
      )}
      <RatingsChart
        className={`treadwell-bar-row__ratings-chart${
          showValueMarker ? '-with-marker' : ''
        }`}
        formattedValue={formattedValue}
        hideFill={hideFill}
        hideLegendNumbers
        hideValueMarker={!showValueMarker}
        scale={scale}
        showZeroValue={showZeroValue}
        styleName={ratingsChartStyleName}
        value={value}
      />
      <div styleName="ratings-label-container">
        {minRatingLabel && <Typography>{minRatingLabel}</Typography>}
        {midRatingLabel && <Typography>{midRatingLabel}</Typography>}
        {maxRatingLabel && <Typography>{maxRatingLabel}</Typography>}
      </div>
    </div>
  );
}

export default TreadwellBarRow;
